"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyTradeHistoryRequest = void 0;
var MyTradeHistoryRequest = /** @class */ (function () {
    function MyTradeHistoryRequest() {
    }
    return MyTradeHistoryRequest;
}());
exports.MyTradeHistoryRequest = MyTradeHistoryRequest;
;
//# sourceMappingURL=myTradeHistory.request.js.map